import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addQuoteSetting = (contract_quote_number,contract_no_of_days) => {
  return axios.post(API + "company/company-settings/", {
    contract_quote_number    ,
    contract_no_of_days    ,

  
  },{headers: authHeader(),});
};
const AddQuoteSettingService = {
    addQuoteSetting,
    
  };
  export default AddQuoteSettingService;